export function getStateKeyByValue<T>(stateObj: Record<number, string>, value: string) {
  return Number(Object.keys(stateObj).find((key) => stateObj[key] === value)) as T
}
